export default {
  title: 'Programa de fidelização',
};
